import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, withProps } from 'recompose';
import { Tooltip } from 'reactstrap';
import { uniqueId } from 'lodash';


const InlineTooltip = ({ children, tooltipText, tooltipId, placement, open, toggleOpen }) => (
  <span>
    <a id={tooltipId}>{children}</a>
    <Tooltip placement={placement} isOpen={open} target={tooltipId} toggle={toggleOpen}>
      {tooltipText}
    </Tooltip>
  </span>
);

const enhance = compose(
  withProps(() => ({
    tooltipId: uniqueId('tooltip-'), // Must be provided in callback form to get invoked for each instance
  })),
  withState('open', 'setOpen', false),
  withHandlers({
    toggleOpen: ({ setOpen }) => () => setOpen(x => !x),
  }),
);

InlineTooltip.propTypes = {
  tooltipId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]).isRequired,
  tooltipText: PropTypes.string.isRequired,
  placement: PropTypes.oneOf([
    'top',
    'bottom',
    'left',
    'right',
    'top left',
    'top center',
    'top right',
    'right top',
    'right middle',
    'right bottom',
    'bottom right',
    'bottom center',
    'bottom left',
    'left top',
    'left middle',
    'left bottom',
  ]),
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
};

InlineTooltip.defaultProps = {
  placement: 'top',
};

export default enhance(InlineTooltip);



// WEBPACK FOOTER //
// ./src/components/InlineTooltip.js